module.exports = __webpack_public_path__ + "img/delete.13b26435.png";